<script>
    import { db } from '../../Database.svelte'
    import { notifier } from '@beyonk/svelte-notifications';
    import QuestionLibrary from '../../Models/QuestionLibraryModel';
    import Loader from '../Loader.svelte';
    import ReferencesField from '../../Forms/CustomFields/ReferencesField.svelte';



    import Tags from '../Tags.svelte';
    import TinyMCEField from '../../Forms/CustomFields/tinymceField.svelte';
    import LibraryMappingModal from './LibraryMappingModal.svelte';
    import {addModal} from "../ModalManager.svelte";

    import LibraryTagModel from '../../Models/LibraryTagModel';

    import {sortBy} from 'lodash-es';
    import QuestionTypes from '../../lib/QuestionTypes';
    import ReferenceLibraryField from '../../Forms/CustomFields/ReferenceLibraryField.svelte';

    export let control_id;

    let libraryTags = LibraryTagModel.getList()

    let details

    function saveControl() {
        $control.save(details).then(() => {
            notifier.success("Control Saved");
        });
    }

    function load_details(ctrl) {
        if (!ctrl) return;

        details = {
            topic_tags: [],
            references: [],
            ...ctrl.details
        }
    }

    async function getMap(mapping) {
        let item =  await db.get(mapping.id);
        let library = await db.get(mapping.library_id);

        return {
            type: library.name,
            text: item.name
        }
    }

    function addAnswerMapping(answer) {

        addModal(LibraryMappingModal).then((mapping) => {
            $control.answer_mappings.addChild({
                answer: answer,
                map: mapping
            }).then(() => {
                notifier.success("Mapping Added");
            })
        });
    }

    function removeMapping(map) {
        map.delete().then(() => {
            notifier.success("Mapping Removed");
        })
    }

    function addTagMapping(tag) {
        addModal(LibraryMappingModal).then((mapping) => {
            $control.tag_mappings.addChild({
                tag: tag.item_id,
                map: mapping
            }).then(() => {
                notifier.success("Mapping Added");
            })
        })
    }


    $: control = QuestionLibrary.getStore(control_id);
    $: load_details($control)
</script>

<div class="box">
    <!--QuestionLibrary/LibraryControl-->
    <Loader loading={!$control} fullscreen={false}>
        <div class="buttons is-right save">
            <button class="button is-right is-success" on:click={saveControl}>
                Save
            </button>
        </div>
        <div class="columns">
            <div class="field column is-narrow">
                <label class="label" for="input_control_number">Control Number</label>
                <div class="control">
                    <input type="text" class="input title is-4" bind:value={details.control_number} id="input_control_number">
                </div>
            </div>
            <div class="field column">
                <label class="label" for="input_control_name">Control Title</label>
                <div class="control">
                    <input type="text" class="input title is-4" bind:value={details.name} id="input_control_name">
                </div>
            </div>
        </div>

        <div class="columns">
            <div class="column flex">
                <h3 class="title is-4">Control Text</h3>
                <textarea class="textarea is-size-4 flex-grow" bind:value={details.text}></textarea>
            </div>
            <div class="column">
                <h3 class="title is-4">Control Level</h3>
                <div class="select is-fullwidth">
                    <select bind:value={details.level}>
                        <option value="1">Level 1</option>
                        <option value="2">Level 2</option>
                        <option value="3">Level 3</option>
                        <option value="4">Level 4</option>
                        <option value="5">Level 5</option>
                    </select>
                </div>
                <h3 class="title is-4">Answer Type</h3>
                <div class="select is-fullwidth">
                    <select bind:value={details.question_type}>
                        <option value="implementation_status_new">Implementation Status</option>
                        <option value="yes_no_new">Yes/No</option>

                        <option value="implementation_status">Implementation Status (old)</option>
                        <option value="yes_no">Yes/No (old)</option>
                        <option value="free_text">Free Text</option>
                    </select>
                </div>
                <h3 class="title is-4">References</h3>
                <ReferenceLibraryField bind:value={details.reference_library} />
                <!--
                    <ReferencesField bind:value={details.references} />
                -->

                <h3 class="title is-4">Topic Tags</h3>
                <div class="field is-grouped- is-grouped-multiline">
                    <div class="control">
                        <Tags bind:tags={details.topic_tags} addKeys={[9,13]} />
                    </div>
                </div>
            </div>
        </div>
        <div class="columns flex-grow">
            <div class="column flex-column">
                <h3 class="title is-4">Supplemental Guidance</h3>
                <TinyMCEField bind:value={details.guidance} classNames="textarea is-size-5 flex-grow" />
                <!-- <textarea class="textarea is-size-5 flex-grow" bind:value={control.guidance} bind:this={guidance_textarea} id="guidance_textarea"></textarea>-->
            </div>
            <div class="column">
                {#if details.question_type != "free_text"}
                    <h1 class="title is-4">Answer Mappings</h1>
                    <table class="table is-striped is-fullwidth">
                        <thead>
                            <tr>
                                <th>Answer</th>
                                <th>Mappings</th>
                            </tr>
                        </thead>
                        <tbody>
                            {#each sortBy(Object.values(QuestionTypes[details.question_type].buttons), ["order"]) as btn (btn.label)}
                                <tr>
                                    <td>{btn.label}</td>
                                    <td>
                                        <table class="table is-fullwidth">
                                            <thead>
                                                <tr>
                                                    <th>Mapping Type</th>
                                                    <th>Mapping Value</th>
                                                    <th>Actions</th>
                                                </tr>
                                            </thead>
                                            <tfoot>
                                                <tr>
                                                    <td colspan=3>
                                                        <button class="button is-pulled-right is-info" on:click={() => addAnswerMapping(btn.value)}>Add Mapping</button>
                                                    </td>
                                                </tr>
                                            </tfoot>
                                            <tbody>
                                                {#key $control}
                                                    {#each [...$control.answer_mappings] as map (map.id)}
                                                    <tr>
                                                        {#if map.details.answer == btn.value}
                                                            {#await getMap(map.details.map)}
                                                                Loading...
                                                            {:then mapping}
                                                                <td>
                                                                    {mapping.type}
                                                                </td>
                                                                <td class="prewrap">
                                                                    {mapping.text}
                                                                </td>
                                                                <td>
                                                                    <button class="button is-danger" on:click={() => removeMapping(map)}>Delete</button>
                                                                </td>
                                                            {/await}
                                                        {/if}
                                                    </tr>
                                                    {/each}
                                                {/key}
                                            </tbody>
                                        </table>
                                    </td>
                                </tr>
                            {/each}
                        </tbody>
                    </table>
                {/if}

                <h1 class="title is-4">Tag Mappings</h1>
                <table class="table is-striped is-fullwidth">
                    <thead>
                        <tr>
                            <th>Answer</th>
                            <th>Mappings</th>
                        </tr>
                    </thead>
                    <tbody>
                        {#if $libraryTags}
                            {#each $libraryTags as tag (tag._id)}
                                <tr>
                                    <td>{tag.name}</td>
                                    <td>
                                        <table class="table is-fullwidth">
                                            <thead>
                                                <tr>
                                                    <th>Mapping Type</th>
                                                    <th>Mapping Value</th>
                                                    <th>Actions</th>
                                                </tr>
                                            </thead>
                                            <tfoot>
                                                <tr>
                                                    <td colspan=3>
                                                        <button class="button is-pulled-right is-info" on:click={() => addTagMapping(tag)}>Add Mapping</button>
                                                    </td>
                                                </tr>
                                            </tfoot>
                                            <tbody>
                                                {#each [...$control.tag_mappings] as map (map.id)}
                                                <tr>
                                                    {#if map.details.tag == tag.item_id}
                                                        {#await getMap(map.details.map)}
                                                            Loading...
                                                        {:then mapping}
                                                            <td>
                                                                {mapping.type}
                                                            </td>
                                                            <td class="prewrap">
                                                                {mapping.text}
                                                            </td>
                                                            <td>
                                                                <button class="button is-danger" on:click={() => removeMapping(map)}>Delete</button>
                                                            </td>
                                                        {:catch e}
                                                            {e}
                                                        {/await}
                                                    {/if}
                                                </tr>
                                                {/each}
                                            </tbody>
                                        </table>
                                    </td>
                                </tr>
                            {/each}
                        {/if}
                    </tbody>
                </table>
            </div>
        </div>
    </Loader>
</div>

<style>
    .box {
        position: relative;
    }

    .flex {
        display: flex;
        flex-direction: column;
        padding: 0;
    }
</style>